export const imageAccommodation = {
  breadcrumbCurrent: "شعار الإقامة",
  heading: "شعار إعلانك",
  subtitle:
    "ارفع الشعار الذي يميّز هذا الإعلان. الصيغ المسموح بها: PNG وJPG وSVG · بحد أقصى 5 ميجابايت.",
  savedLogoAlt: "الشعار المحفوظ",
  activeBadge: "الشعار النشط",
  change: "تغيير",
  drop: {
    release: "أفلت هنا",
    newLogo: "شعار جديد",
    uploadLogo: "ارفع شعارك",
    dragOr: "اسحب أو",
    clickLink: "انقر",
    formats: "PNG · JPG · SVG · بحد أقصى 5 ميجابايت",
  },
  importButton: "استيراد شعار من إعلان آخر",
  crop: {
    removeImage: "إزالة الصورة",
    tip: "حرّك القصاصة واضبطها. نسبة 2:1 (مثالية للشعارات الأفقية).",
    saving: "جارٍ الحفظ…",
    save: "حفظ الشعار",
  },
  actions: {
    cancel: "إلغاء",
  },
  applyModal: {
    title: "تطبيقه على إعلانات أخرى؟",
    subtitle: "اختر الإعلانات التي تريد نسخ الشعار نفسه إليها.",
    logoAlt: "الشعار",
    selectAll: "تحديد الكل",
    progress: "جارٍ التطبيق {done}/{total}…",
    skip: "تخطّي",
    applying: "جارٍ التطبيق…",
    applyToBtn: "تطبيق على {count} إعلان | تطبيق على {count} إعلانات",
  },
  importModal: {
    title: "استيراد الشعار",
    subtitle: "اختر شعار إعلان آخر لاستخدامه في هذا الإعلان.",
    loading: "جارٍ تحميل الإعلانات…",
    empty: "لا يوجد أي إعلان له شعار بعد.",
    progress: "جارٍ استيراد الشعار…",
    importing: "جارٍ الاستيراد…",
  },
  defaultListingName: "إعلان",
  toasts: {
    invalidFormat: "صيغة غير صالحة. استخدم PNG أو JPG أو SVG.",
    fileTooLarge: "يتجاوز الملف الحد الأقصى البالغ {max} ميجابايت.",
    selectBeforeSave: "اختر شعارًا واضبطه قبل الحفظ.",
    propertyNotFound: "تعذّر العثور على العقار المرتبط بهذا الإعلان.",
    saveSuccess: "تم حفظ الشعار بنجاح",
    saveError: "حدث خطأ أثناء حفظ الشعار.",
    listingLoadError: "تعذّر تحميل معلومات الإعلان.",
    applySuccess:
      "تم تطبيق الشعار على {count} إعلان بنجاح | تم تطبيق الشعار على {count} إعلانات بنجاح",
    applyError:
      "تعذّر التطبيق على {count} إعلان | تعذّر التطبيق على {count} إعلانات",
    listingsLoadError: "تعذّر تحميل الإعلانات.",
    propertyNotFoundImport: "تعذّر العثور على عقار هذا الإعلان.",
    importSuccess: 'تم استيراد شعار "{name}" بنجاح',
    importError: "حدث خطأ أثناء استيراد الشعار.",
  },
};
